import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const { DateRangePicker } = ReactDates

export default class VsDateRangePicker extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null,
      focusedInput: null
    }

    this.handleChangeDates = this.handleChangeDates.bind(this)
  }

  handleChangeDates({ startDate, endDate }) {
    this.setState({ startDate, endDate })
    this.props.onDatesChange({ startDate, endDate })
  }

  // TODO: 英語と日本語以外

  get checkinString () {
    return this.isJapanese ? 'チェックイン' : 'Check-in'
  }

  get checkoutString () {
    return this.isJapanese ? 'チェックアウト' : 'Check-out'
  }

  get isJapanese () {
    return this.languageLocale == 'ja'
  }

  get languageLocale () {
    return (this.languageLocaleMeta && this.languageLocaleMeta.content) || 'ja'
  }

  get languageLocaleMeta () {
    return document.querySelector('meta[name="language-locale"]')
  }

  render() {
    let numberOfMonths
    let daySize

    if (window.innerWidth < 655) {
      numberOfMonths = 1
      daySize = 35
    } else {
      numberOfMonths = 2
      daySize = 38
    }

    moment.locale(this.props.lang)

    return (
      <div className="notranslate vs-date-range-picker-container">
        <DateRangePicker
          hideKeyboardShortcutsPanel
          startDatePlaceholderText={this.props.startDatePlaceholderText || this.checkinString}
          endDatePlaceholderText={this.props.endDatePlaceholderText || this.checkoutString}
          startDate={this.state.startDate}
          startDateId="checkin"
          endDate={this.state.endDate}
          endDateId="checkout"
          onDatesChange={this.handleChangeDates}
          focusedInput={this.state.focusedInput}
          onFocusChange={(focusedInput) => {
            this.setState({ focusedInput })
            this.props.onFocusChange(focusedInput)
          }}
          daySize={daySize}
          showDefaultInputIcon={this.props.showDefaultInputIcon}
          numberOfMonths={numberOfMonths}
          displayFormat={this.props.displayFormat}
          monthFormat={this.props.lang == 'ja' ? 'YYYY年MMMM' : 'MMMM YYYY'}
        />
      </div>
    )
  }
}

VsDateRangePicker.propTypes = {
  onDatesChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  showDefaultInputIcon: PropTypes.bool,
  lang: PropTypes.string,
  startDatePlaceholderText: PropTypes.string,
  endDatePlaceholderText: PropTypes.string,
  displayFormat: PropTypes.string
}

VsDateRangePicker.defaultProps = {
  showDefaultInputIcon: false,
  lang: 'ja',
  startDatePlaceholderText: '',
  endDatePlaceholderText: '',
  displayFormat: '',
  onFocusChange: () => {}
}
